import { Children, ReactElement } from "react";
import { Box, Flex, useMantineTheme } from "@mantine/core";
import { IWarningCardProps } from "./types";
import CustomCard from "../CustomCard";
import IconWarning from "@common/components/icons/IconWarning";
import CardTitle from "../CardTitle";

export default function WarningCard({
  withWarningIcon,
  icon,
  iconSize,
  title,
  extra,
  children,
  ...customCardProps
}: IWarningCardProps): ReactElement {
  const theme = useMantineTheme();

  const childrenCount = Children.toArray(children).length;

  return (
    <CustomCard borderColor="yellow.3" bg="yellow.1" {...customCardProps}>
      <Flex
        align="flex-start"
        direction="row"
        gap="xs"
        justify="flex-start"
        wrap="nowrap"
        w="100%"
      >
        {(withWarningIcon || icon) && (
          <Box miw={iconSize || theme.spacing.xl} ml={-1} mt={-2}>
            {icon || <IconWarning size={iconSize || theme.spacing.xl} />}
          </Box>
        )}

        <Box w="100%">
          {(title || extra) && (
            <Flex
              align="center"
              direction="row"
              gap="xs"
              justify="space-between"
              wrap="nowrap"
              mb={childrenCount > 0 ? "xs" : 0}
              mt={-2}
              w="100%"
            >
              {title && <CardTitle>{title}</CardTitle>}
              <Box>{extra}</Box>
            </Flex>
          )}

          {children}
        </Box>
      </Flex>
    </CustomCard>
  );
}
